import { ReactComponent as MasterCardSvg } from 'src/assets/icons/master-card-svg.svg';
import styled from 'styled-components';

export const MasterCardIcon = styled(MasterCardSvg)`
  height: 4.375rem;
`;
